
import React, { useEffect, useState, useCallback } from 'react';
import { Container, Row, Col, Card, Tab, Tabs, Nav } from 'react-bootstrap';
import Footer from './Footer';
import { Helmet } from "react-helmet-async";
import axios from 'axios';
import parse from 'html-react-parser';

function Projects() {
  const [activeTab, setActiveTab] = React.useState(null);
  const [isSticky, setIsSticky] = useState(false);
  const [project, setProject] = useState(null);
  const [error, setError] = useState(null);

  const handleScroll = () => {
    setIsSticky(window.scrollY > 100);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fetch data with caching and error handling
  const fetchData = useCallback(async () => {
    try {
      const cachedData = localStorage.getItem('projectsData');
      if (cachedData) {
        setProject(JSON.parse(cachedData)); // Use cached data
      } else {
        const response = await axios.get('https://admin.techno-elevators.com/api/getProjectsPageDataBySlug/projects');
        const data = response.data.data;
        setProject(data);
        localStorage.setItem('projectsData', JSON.stringify(data)); // Cache the data
      }
    } catch (err) {
      setError('Failed to fetch data. Please try again later.');
      console.error(err);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (error) {
    return <div>{error}</div>;
  }

  if (!project) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Helmet>
        <title>Techno Elevators Oman | Elevator & Escalator Projects in Oman</title>
        <meta name="description" content="Have a look at successful elevator and escalator projects by Techno Elevators Oman. Providing reliable travelator installations and maintenance services to enhance building accessibility across Oman." />
        <meta name="keywords" content="techno elevators for villas,techno elevators for office buildings,commercial techno lift installation,high-rise techno elevators,techno elevator services in Muscat,elevator installation cost,home elevator installation near me,residential elevator installation,home elevator installers,lift installation services,elevator repair near me" />
  <link rel="canonical" href="https://www.techno-elevators.com/projects" />
      </Helmet>

      <Container fluid>
        {/* Header Section */}
        <Row className="text-center mt-5 mb-3">
          <div className="section-title">
            <h2>Our Projects</h2>
          </div>
          <Col lg={12}>
            <p className="text-center" style={{ width: '700px', margin: 'auto' }}>
              {project?.content?.highlight_en && parse(project?.content?.highlight_en)}
            </p>
          </Col>
        </Row>
      </Container>

      <Container>
        {/* Projects Section */}
        <Row className={isSticky ? 'sticky-top' : ''}>
          <Tab.Container id="left-tabs-example" defaultActiveKey={activeTab || '12'} className={isSticky ? 'sticky-top' : ''}>
            <Row>
              <Col sm={3}>
                <Nav variant="pills" className={`${isSticky ? 'mt-5' : 'mb-5'} flex-column`}>
                  {project?.projects?.map((item) => (
                    <Nav.Item className="mb-3" key={item.id}>
                      <Nav.Link eventKey={item.id}>{item.category_title_en}</Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </Col>
              <Col sm={9} className={isSticky ? 'mt-5' : ''}>
                <Tab.Content>
                  {project?.projects?.map((item) => (
                    <Tab.Pane eventKey={item.id} key={item.id}>
                      <Row>
                        {item.sections?.map((section, index) => (
                          <Col lg={6} md={6} sm={10} key={index} className="d-flex justify-content-center">
                            <Card className="project-card h-100 shadow-sm">
                              <Card.Body>
                                <Card.Title className="heading-names">{section.section_title_en}</Card.Title>
                                <Card.Text>{section.description_en && parse(section.description_en)}</Card.Text>
                              </Card.Body>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    </Tab.Pane>
                  ))}
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Row>
      </Container>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default Projects;

